import { render, staticRenderFns } from "./results-report.vue?vue&type=template&id=6afe47a8&scoped=true&"
import script from "./results-report.vue?vue&type=script&lang=ts&"
export * from "./results-report.vue?vue&type=script&lang=ts&"
import style0 from "./results-report.vue?vue&type=style&index=0&id=6afe47a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afe47a8",
  null
  
)

export default component.exports